
import { Component, Prop, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { nameInfoType } from "@/types/Application/CommonInformation";

@Component({
    components:{
        UnderlineForm,
        CheckBox       
    }
})
export default class Form4Layout extends Vue {

    @Prop({required:true})
    result!: any;    
    
    @applicationState.State
    public applicantName!: nameInfoType;    

    dataReady = false; 
    liveAlone = false;
    numberOfChildren = 0;
    liveWithAdult = false;

    contributionAmount = 0;  
    contributionFreq = '';
    ContributionFreqDesc = '';
    partnerName = '';
    partnerAnnualIncome = 0;
    adultDetails = [];    
   
    mounted(){
        this.dataReady = false;
        this.extractInfo();       
        this.dataReady = true;        
    }   

    public extractInfo(){        
        this.liveAlone = false;
        this.numberOfChildren = 0;
        this.liveWithAdult = false; 
        this.partnerName = '';
        this.partnerAnnualIncome = 0;
        this.adultDetails = [];
        this.contributionAmount = 0;  
        this.contributionFreq = '';       
        
        this.liveAlone = this.result?.incomeOtherPersonHouseholdLiveAlone && 
                            this.result.incomeOtherPersonHouseholdLiveAlone == "Yes";
        if(!this.liveAlone){

            this.liveWithAdult =  this.result?.incomeOtherPersonHouseholdLiveWithAdult && 
                            this.result.incomeOtherPersonHouseholdLiveWithAdult == "Yes";

            this.numberOfChildren = this.result?.incomeOtherPersonHouseholdNumberOfChildren?this.result.incomeOtherPersonHouseholdNumberOfChildren:0; 

            if(this.liveWithAdult){

                if(this.result?.incomeOtherPersonHouseholdFSSurvey){

                    for(const otherAdultInfo of this.result.incomeOtherPersonHouseholdFSSurvey){

                        let adultInfo = {
                            name: otherAdultInfo.adultFullName?otherAdultInfo.adultFullName:'', 
                            income: otherAdultInfo.adultAnnualIncome?Number(otherAdultInfo.adultAnnualIncome):0
                        }
                        
                        if(otherAdultInfo.married == "y"){
                            this.partnerName = adultInfo.name;
                            this.partnerAnnualIncome = adultInfo.income;
                        } else {
                            this.adultDetails.push(adultInfo);
                        }
                                   
                    }
                }
            }
        }

        if(this.liveWithAdult)
            this.getContributionInfo();
                    
    }
    
    public getContributionInfo(){           

        if(this.result?.contributionTowardExpensesFSSurvey){  

            const contributionInfo = this.result.contributionTowardExpensesFSSurvey

            this.contributionAmount = contributionInfo.otherAdultContribution?contributionInfo.otherAdultContribution:0;  
            this.contributionFreq = contributionInfo.contributionFrequency?contributionInfo.contributionFrequency:'';
            if(contributionInfo.contributionFrequency == "other"){
                this.contributionFreq = contributionInfo.contributionFrequencyComment?contributionInfo.contributionFrequencyComment:'';
            } else {
                this.contributionFreq = contributionInfo.contributionFrequency;
            }
        }               
    }

 
 
}
